import { useSelector } from "react-redux";
import { calculatorEdd } from "../utils/eddCalculator";

function useEdd({ order }) {
  const {
    edd_setting: { cutoff_time, processing_time, business_days, timezone },
    transit_time,
  } = useSelector((state) => state.edd);

  const { timezone: merchant_timezone } = useSelector(
    (state) => state.featureSetting
  );
  // console.log(transit_time);
  const newTransitTime = transit_time.map((zone) => {
    return {
      ...zone,
      shipping_destination_country:
        typeof zone.shipping_destination_country === "string"
          ? JSON.parse(zone.shipping_destination_country)
          : zone.shipping_destination_country,
      shipping_method:
        typeof zone.shipping_method === "string"
          ? JSON.parse(zone.shipping_method)
          : zone.shipping_method,
    };
  });

  const shippingAdress = JSON.parse(order?.shipping_address)?.country_code;

  const edd = calculatorEdd({
    cutoff_time,
    merchant_timezone,
    edd_timezone: timezone,
    created_time: order?.created_at,
    transit_times: newTransitTime,
    shipping_country: shippingAdress,
    courier: order?.tracking_company,
    processing_time,
    business_days,
  });

  return edd;
}

export default useEdd;
